export default __webpack_public_path__ + "static/media/PMR-Sunset-Round-700px.f83432ab.jpg";